import {VegasUI} from "../../../../../../modules/index.esm";

window.Catalog = {
	setUrlData: function (url) {
		history.pushState({}, null, url)
	},
	reload: function () {
		let route = location.href;

		$([document.documentElement, document.body]).animate({
			scrollTop: $('.catalog-content').offset().top - 180
		}, 500);

		$.get(route, {}, function (data) {
			if (data.view) {
				let $content = $('.catalog-content');
				$content.html(data.view);

				let $b = $('section.breadcrumbs');
				$b.after(data.breadcrumbs)
				$b.remove();

				$('title').text(data.title);

				VegasUI.boot();
			}
		});
	},
};

$(document).on('click', '#catalog-categories [data-load-category]', function () {
	let url = $(this).attr('href');

	let $catalogCategories = $(this).closest('#catalog-categories');
	$catalogCategories.find('.category.active').removeClass('active');
	$(this).addClass('active');

	$('.header-wrapper').addClass('fixed-top')

	Catalog.setUrlData(url);
	Catalog.reload();

	return false;
});
